import { render, staticRenderFns } from "./UnsubscribeRequestPopup.vue?vue&type=template&id=73384726&scoped=true&"
import script from "./UnsubscribeRequestPopup.vue?vue&type=script&lang=ts&"
export * from "./UnsubscribeRequestPopup.vue?vue&type=script&lang=ts&"
import style0 from "./UnsubscribeRequestPopup.vue?vue&type=style&index=0&id=73384726&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73384726",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2332429520/src/pickl-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('73384726')) {
      api.createRecord('73384726', component.options)
    } else {
      api.reload('73384726', component.options)
    }
    module.hot.accept("./UnsubscribeRequestPopup.vue?vue&type=template&id=73384726&scoped=true&", function () {
      api.rerender('73384726', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Brand/UnsubscribeRequestPopup.vue"
export default component.exports